// Configuración del producto por DOS EJES independientes:
//   - manejaPrecios (P): el negocio valoriza ventas/costos (órdenes con precio,
//     gestión de costos, indicadores valorizados en análisis).
//   - pickingConOperarios (O): hay operarios dedicados con tareas de picking
//     asignadas/optimizadas; si no, la salida es un egreso directo.
//   - sectorSalud (S): institución de salud (hospital/clínica). Activa el
//     vocabulario clínico, el módulo de Trazabilidad de Dispositivos Médicos
//     (NT 226/247) y oculta los módulos comerciales de venta.
//
// Pyme/Empresa quedan como PRESETS de conveniencia de esos dos ejes.

export const EDITIONS = {
  pyme: { key: 'pyme', label: 'Pyme' },
  empresa: { key: 'empresa', label: 'Empresa' },
  salud: { key: 'salud', label: 'Salud' }
}

export const DEFAULT_EDITION = 'pyme'

// Presets: combinación de los dos ejes para cada edición.
export const EDITION_PRESETS = {
  pyme: { manejaPrecios: false, pickingConOperarios: false, sectorSalud: false },
  empresa: { manejaPrecios: true, pickingConOperarios: true, sectorSalud: false },
  salud: { manejaPrecios: false, pickingConOperarios: true, sectorSalud: true }
}

// Estado inicial por defecto (antes del onboarding).
export const DEFAULT_FLAGS = { manejaPrecios: false, pickingConOperarios: false, sectorSalud: false }

// Textos que cambian en modo salud (menú, títulos). Uso: vocab('egresos', flags)
const VOCAB_SALUD = {
  egresos: 'Salidas a servicios',
  clientes: 'Servicios / destinos',
  cliente: 'Servicio o destino',
  productos: 'Insumos y dispositivos',
  producto: 'Insumo / dispositivo',
  bodega: 'Bodega central'
}
const VOCAB_BASE = {
  egresos: 'Egresos',
  clientes: 'Clientes',
  cliente: 'Cliente',
  productos: 'Productos',
  producto: 'Producto',
  bodega: 'Bodega'
}
export function vocab(key, flags) {
  const S = !!(flags && flags.sectorSalud)
  return (S ? VOCAB_SALUD : VOCAB_BASE)[key] || key
}

// ¿El módulo `moduleKey` es visible dados los dos ejes?
// Matriz de vista de salida:
//   P=no,O=no → Egresos | P=no,O=sí → Picking Inteligente
//   P=sí,O=sí → Gestión de Órdenes | P=sí,O=no → Egresos (con precios)
export function isModuleVisible(moduleKey, flags) {
  const P = !!(flags && flags.manejaPrecios)
  const O = !!(flags && flags.pickingConOperarios)
  const S = !!(flags && flags.sectorSalud)

  // Módulos exclusivos del sector salud
  if (['trazabilidad-dm', 'mi-servicio', 'destinos', 'documentos-dte', 'cumplimiento', 'consignaciones'].includes(moduleKey)) return S
  // En salud no hay venta a clientes: sin órdenes de venta, costeo por ventas ni despachos a clientes.
  // La salida de bodega es siempre un Egreso hacia un servicio/destino interno.
  if (S && ['orders', 'cost-management', 'despachos', 'wave-picking'].includes(moduleKey)) return false
  if (S && moduleKey === 'egresos') return true

  switch (moduleKey) {
    // Documento comercial valorizado que genera picking asignado
    case 'orders':
      return P && O
    // Operación con operarios dedicados (picking asignado/optimizado)
    case 'intelligent-picking':
    case 'service-assignment':
    case 'wave-picking':
    case 'despachos':
      return O
    // Salida directa sin operarios
    case 'egresos':
      return !O
    // Costeo: solo si valoriza
    case 'cost-management':
      return P
    // Análisis siempre visible; los KPIs valorizados se condicionan en la vista.
    // Resto de módulos operativos: siempre visibles.
    default:
      return true
  }
}

// Deriva la etiqueta de edición desde los dos ejes (compatibilidad).
export function editionFromFlags(flags) {
  const P = !!(flags && flags.manejaPrecios)
  const O = !!(flags && flags.pickingConOperarios)
  if (flags && flags.sectorSalud) return 'salud'
  if (P && O) return 'empresa'
  if (!P && !O) return 'pyme'
  return 'custom'
}
